export async function getRecaptchaToken(action: string): Promise<string | undefined> {
  if (!process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY) return undefined;

  return window.grecaptcha?.enterprise.execute(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY, { action });
}
